import React from "react";

// Subtle animated data-flow background: horizontal lines + pulsing dots.
// Purely decorative, GPU-friendly, no scroll cost.
export const DataFlowBg = ({ density = 6, className = "" }) => {
  const lines = Array.from({ length: density });
  const dots = Array.from({ length: 10 });
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      <div className="absolute inset-0 bg-circuit opacity-[0.35]" />
      <div className="absolute inset-0">
        {lines.map((_, i) => {
          const top = 8 + (i * 84) / density;
          const duration = 9 + (i % 4) * 3;
          const delay = (i * 1.7) % 8;
          return (
            <div
              key={i}
              className="flow-line"
              style={{
                top: `${top}%`,
                width: "40%",
                animationDuration: `${duration}s`,
                animationDelay: `${delay}s`,
              }}
            />
          );
        })}
      </div>
      <div className="absolute inset-0">
        {dots.map((_, i) => (
          <span
            key={i}
            className="pulse-dot absolute rounded-full"
            style={{
              width: 4,
              height: 4,
              background: i % 3 === 0 ? "#FF6B35" : "#0089C8",
              left: `${(i * 97) % 100}%`,
              top: `${(i * 53 + 12) % 100}%`,
              animationDelay: `${(i * 0.4) % 2.5}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default DataFlowBg;
